import React, { HTMLAttributes } from 'react'
import { STypographyDesc } from '@components/Typography'

export interface IContact extends HTMLAttributes<HTMLAnchorElement> {
  href?: string
  desc?: string
}

const Contact: React.FC<IContact> = ({ desc, children }) => {
  return (
    <a style={{ color: '#333f48' }} href="tel:84957847330">
      {children}
      {desc && (
        <STypographyDesc color="gray" lineHeight="14px">
          {desc}
        </STypographyDesc>
      )}
    </a>
  )
}

export default Contact
